import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from '@hooks/useAccessToken';
import {
  fetchPlayerHistory,
  type PlayerHistoryResponse
} from '@api-service/player-history';

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export type UsePlayerHistoryOptions = {
  id: string | null | undefined;
  limit?: number;
  season?: number;
  enabled?: boolean;
};

export const usePlayerHistory = ({
  id,
  limit,
  season,
  enabled = true
}: UsePlayerHistoryOptions) => {
  const { accessToken, accessTokenIsFetching } = useAccessToken();

  return useQuery<PlayerHistoryResponse>({
    queryKey: ['playerHistory', id, limit ?? null, season ?? null],
    queryFn: () => {
      if (!id) {
        throw new Error('Player id is required');
      }
      return fetchPlayerHistory({
        id,
        ...(accessToken ? { accessToken } : {}),
        ...(limit !== undefined ? { limit } : {}),
        ...(season !== undefined ? { season } : {})
      });
    },
    enabled: enabled && Boolean(id) && !accessTokenIsFetching,
    staleTime: FIVE_MINUTES_IN_MS,
    refetchOnWindowFocus: false
  });
};
